// extracted by mini-css-extract-plugin
export default {"ripple":"Ripple_ripple__agxbI","fill":"Ripple_fill__FA9za"};